import { subMonths, startOfMonth, endOfMonth, format } from 'date-fns'
import { TOP10_CHART, ITEM_COVERAGE_CHART, CHART_DEFINITION } from '@/misc/desktopCharts'
import { getDataByStartAndEndDate, getTotalByMonth } from './lib/callChartAPI'

const getChartDataAndTotalUsingDiffAPI = async (chartName, currentDate, storeId) => {
  const prevMonthDate = subMonths(currentDate, 1)
  const responses = await Promise.all([
    getDataByStartAndEndDate(chartName, startOfMonth(currentDate), endOfMonth(currentDate), storeId),
    getTotalByMonth(chartName, format(currentDate, 'yMM'), storeId),
    getTotalByMonth(chartName, format(prevMonthDate, 'yMM'), storeId)
  ])
  return {
    data: responses[0].data || [],
    total: responses[1].data.val || 0,
    prevTotal: responses[2].data.val || 0
  }
}

const getChartDataWithTotalAtSameTime = async (chartName, currentDate, storeId) => {
  const prevMonthDate = subMonths(currentDate, 1)
  const responses = await Promise.all([
    getDataByStartAndEndDate(chartName, startOfMonth(currentDate), endOfMonth(currentDate), storeId),
    getDataByStartAndEndDate(chartName, startOfMonth(prevMonthDate), endOfMonth(prevMonthDate), storeId)
  ])
  return {
    data: responses[0].data || [],
    total: responses[0].total || 0,
    prevTotal: responses[1].total || 0
  }
}

const top10Chart = async (chartName, currentDate, storeId) => {
  const topItems = await getTotalByMonth(chartName, format(currentDate, 'yMM'), storeId)
  return topItems.data && topItems.data.rank ? topItems.data && topItems.data.rank : []
}

const getItemCoverageChartData = async (chartName, currentDate, storeId) => {
  const prevMonthDate = subMonths(currentDate, 1)
  const responses = await Promise.all([
    getTotalByMonth(chartName, format(prevMonthDate, 'yMM'), storeId),
    getTotalByMonth(chartName, format(currentDate, 'yMM'), storeId)
  ])
  let total = Object.values(responses[0].data).reduce((t, n) => t + n) || 0
  let prevTotalVal = Object.values(responses[1].data).reduce((t, n) => t + n) || 0
  return {
    'successfully-parsed': responses[0].data[0] || 0,
    'unsupported-category': responses[0].data[3] || 0,
    'missing-measurements': responses[0].data[4] || 0,
    'no-measurements': responses[0].data[5] || 0,
    'vs-optimization-in-progress': responses[0].data[-1] || 0,
    'total-percentage': total !== 0 ? responses[0].data[0] / total : 0,
    'prevTotal': prevTotalVal !== 0 ? responses[1].data[0] / prevTotalVal : 0,
    total
  }
}

export default async (chartName, currentDate, storeId) => {
  if (chartName === TOP10_CHART) {
    return {
      data: await top10Chart(chartName, currentDate, storeId)
    }
  }

  if (chartName === ITEM_COVERAGE_CHART) {
    return getItemCoverageChartData(chartName, currentDate, storeId)
  }

  const chartDefine = CHART_DEFINITION.find(define => define.name === chartName)
  if (chartDefine.callAPIWithMonthParam) {
    return getChartDataAndTotalUsingDiffAPI(chartName, currentDate, storeId)
  } else {
    return getChartDataWithTotalAtSameTime(chartName, currentDate, storeId)
  }
}
